import { createFuncDef } from "../../../../services/utils/index.js";

export default setFieldValues => [
  createFuncDef((id, data) => {
    setFieldValues({
      aboutMe: data.aboutMe,
    });
  }),
];
